import React, { useEffect, useRef, useState } from "react";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { sendAnalytics } from "../../../action/homeAction";
import { getDefaultAnalyticsLabel } from "../../JS/utility";
import SignatureCanvas from 'react-signature-canvas'
import html2canvas from 'html2canvas';
import { closeOrderPopUp } from "../../action/hCommerce2";
import clientConfigApi from "../../../../src/config/config"
import { CMSPath } from "../../../config/constant";
import { scrollToTop } from "../../../JS/scrollToTop";

const Disclaimer = (props) => {

    const { t } = props;
    const sigCanvas = useRef({});
    const [langCode, setLangCode] = useState("");
    const [disclaimerType, setDisclaimerType] = useState("generalDisclaimer");
    const [enableAccept, setEnableAccept] = useState(false);
    const [dislaimerText, setDisclamierText] = useState("");
    const [disclaimerSSArray, setDisclaimerSSArray] = useState([]);
    const [agreeDisclaimer, setAgreeDisclaimer] = useState(false);


    const getDefaultLanguage = () => {

        let found = false;
        props.cardChecksData.disclaimerLanguageList && props.cardChecksData.disclaimerLanguageList.map((lang) => {
            if (lang.default) {
                found = true;
                setLangCode(lang.code)
            }
        })

        if (!found) {
            setLangCode("en");
        }
    }

    const getDisclaimerText = async () => {
        props.setLoader(true, "Please wait...")
        handleResetCanvas();

        const config = {
            headers: { Authorization: `Bearer ${localStorage.getItem('GuestJourneySessionToken')}` }
        };

        try {
            let data = await clientConfigApi.get(`assets?fileType=html&type=${disclaimerType}&languageCode=${langCode}&reservationNumber=${props.reservationNumber}`, config)


            const placeholders = {
                "#PASSPORTNUMBER": props.userDetails.passportNumber,
                "#NATIONALITY": props.userDetails.nationality,
                "#EMAIL": props.userDetails.email,
                "#PHONE": props.userDetails.phone,
                "#ADDRESSLINE1": props.checkInAddress.addressLine1,
                "#ADDRESSLINE2": props.checkInAddress.addressLine2,
                "#CITY": props.checkInAddress.city,
                "#POSTALCODE": props.checkInAddress.postalCode,
                "#FIRSTNAME": props.userDetails.firstName,
                "#LASTNAME": props.userDetails.lastName,
                "#GUESTNAME": props.userDetails.guestName
            };

            let disclaimerTextHTML = data.data;

            for (const [placeholder, value] of Object.entries(placeholders)) {
                const regex = new RegExp(placeholder, 'g');
                disclaimerTextHTML = disclaimerTextHTML.replace(regex, value || "");
            }

            setDisclamierText(disclaimerTextHTML);

            scrollToTop();
            props.setLoader(false)
        } catch (e) {
            props.setLoader(false)
            props.setAPIFailScreen(true);
        }
    }

    const handleResetCanvas = () => {
        sigCanvas.current.clear();
        setEnableAccept(false);
    }

    const handleAcceptDisclaimer = () => {

        if (props.isChildAsAccompanyGuest) {
            setDisclaimerType("childDisclaimer");
            return;
        }

        props.goNext(disclaimerSSArray);
    }

    const takeScreenshot = () => {
        props.setLoader(true, "Please wait...")
        const divToCapture = document.getElementById('legal_document');
    
        if (divToCapture) {

            // Apply inline CSS if needed for A4 size formatting
            const originalWidth = divToCapture.style.width;
            const originalPadding = divToCapture.style.padding;
            divToCapture.style.width = '210mm'; // A4 width
            divToCapture.style.padding = '20px'
    
            html2canvas(divToCapture, {
                useCORS: true, // Handle cross-origin images
                scale: 2, // Increase resolution
                scrollX: 0, // Handle scroll position
                scrollY: -window.scrollY // Adjust scroll position
            }).then(canvas => {
                const screenshot = canvas.toDataURL("image/jpeg", 0.3);
    
                // Restore original styles
                divToCapture.style.width = originalWidth;
                divToCapture.style.padding = originalPadding;
    
                setDisclaimerSSArray(prevArray => [...prevArray, screenshot]);
            }).catch(error => {
                console.error('Error capturing screenshot:', error);
                props.setLoader(false);
            });
        } else {
            props.setLoader(false);
            console.error('Element with specified ID not found');
        }
    };

    useEffect(() => {
        if (disclaimerSSArray.length > 0) {
            handleAcceptDisclaimer();
        }

        console.log(disclaimerSSArray)
    }, [disclaimerSSArray])


    const handleNext = () => {
        const inputs = document.querySelectorAll('.preview-text input, .preview-text select');

        let isEmpty = false;
        let reverseInputsArray = Array.from(inputs).reverse();
        reverseInputsArray.forEach(input => {
            if (input.classList.contains('discalimer_mandatory') && (!input.value || input.value.trim() == '')) {
                const fieldname = input.name;
                if(fieldname){
                    props.closeOrderPopUp(true, `Please enter ${fieldname}`, "", true)
                } else {
                    props.closeOrderPopUp(true, "Please enter all the mandatory fields to proceed", "", true)

                }

                isEmpty = true;
                return;
            }
        });

        // If isEmpty is true, some input is empty
        if (isEmpty) {
            return;
        }
        takeScreenshot();
    }

    useEffect(() => {

        if (langCode && disclaimerType) {
            getDisclaimerText();
        }

    }, [langCode, disclaimerType])


    useEffect(() => {

        scrollToTop();
        getDefaultLanguage();

        let label = getDefaultAnalyticsLabel({ appVersion: props.installedAppVersion ? `${props.installedAppVersion}(${props.installedAppBuildNo})` : "" })
        const checkinSessionToken = localStorage.getItem("checkinSessionToken");

        props.sendAnalytics(
            null, // as no guesdetails in logout state 
            props.currentWidgetObj.widgetType || "Mobile Check-in",
            "DISCLAIMER",
            { ...label, "layoutTab": props.currentHomePage.tabName, "element": "widget", "pageName": "DISCLAIMER", "widgetSessionId": checkinSessionToken },
            0,
            false // guest is not logged in
        );
    }, [])

    return (
        <div class="main-container show-disclaimer" >
            <header class="inner-pages w-footer subpages">
                <a onClick={props.goBack} class="button-back"></a>
                <div class="heading align-center">
                    <div class="splash-brand">
                        <img src={`${CMSPath}${props.logo}`} />
                    </div>
                    {/* <p class="bold">{props.currentWidgetObj.widgetType == "Pre Check-in" ? t('pre_checkIn.preCheckIn_heading') : t('check_in.guest_checkin')}</p> */}
                </div>
            </header>
            <section class="widgets padding-0 margin-0 container-bg">

                <div class="widget-header widget-header-checkin-inner">
                    { props.currentWidgetObj.widgetHeaderImageUrl && 
                        <div class="widget-header-img">
                            <img src={`${CMSPath}${props.currentWidgetObj.widgetHeaderImageUrl}`} alt={props.currentWidgetObj.displayName} />
                        </div>
                    }
                       <div class="widget-header-title" dangerouslySetInnerHTML={{  __html : props.currentWidgetObj.widgetType == "Pre Check-in" ? t('pre_checkIn.preCheckIn_heading') : t('check_in.guest_checkin') }}></div>
                </div>

                <div class="widgets">

                    <div class="row padding-top-1 padding-bottom-0 padding-right-1 padding-left-1">
                        <h2>Attention</h2>
                        <div class="inline-select">
                            {props.cardChecksData.disclaimerLanguageList &&
                                <>
                                    <label>Select Language</label>
                                    <select onChange={(e) => setLangCode(e.target.value)} className="lang">
                                        {props.cardChecksData.disclaimerLanguageList.map((language, index) => (
                                            <option key={index} value={language.code} selected={langCode == language.code} >
                                                {language.label}
                                            </option>
                                        ))}
                                    </select>
                                </>
                            }
                        </div>
                    </div>

                    <div class="form-window">
                        <div class="form-window-heading">
                            {t('check_in.disclaimerHeading')}
                        </div>
                        <div class="row padding-top-1 padding-bottom-1 padding-right-1 padding-left-1">
                            <div id="legal_document" class="preview-text showall">
                                <div class="form-row margin-bottom-2">
                                    <div dangerouslySetInnerHTML={{ __html: dislaimerText }}></div>
                                </div>

                                <div class="form-row checkbox">
                                    <input type="checkbox" id="Terms1" name="Terms1" value={agreeDisclaimer} onClick={() => setAgreeDisclaimer(!agreeDisclaimer)} />
                                    <label for="Terms1">{t('check_in.disclaimer_terms_condition')}</label>
                                </div>

                                <div class="form-row margin-bottom-1 sigCanvasContainer">
                                    <label for="guestName">{t('check_in.your_name')}</label>
                                    <SignatureCanvas
                                        ref={sigCanvas}
                                        onBegin={() => setEnableAccept(true)}
                                        penColor={props.menuColor.assetBackgroundSelectorColor}
                                        canvasProps={{ className: 'sigCanvas' }}
                                    />
                                </div>
                            </div>
                            <div class="form-controls">
                                <button onClick={handleResetCanvas} class="w-100 margin-bottom-2">{t('check_in.reset')}</button>
                                <button class="primary w-100" disabled={!enableAccept || !agreeDisclaimer} onClick={handleNext}>{t('check_in.accept')}</button>
                            </div>
                        </div>
                    </div>

                </div>
            </section>
        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        menuColor: state.store.home.MenuColor,
        checkInAddress : state.store2.checkInAddress,
        logo: state.store.home.currentDuration.brandingInfo ?
            state.store.home.currentDuration.brandingInfo.hotelLogoImageUrl : "",
        currentWidgetObj: state.store.sideNavBar.currentWidget,
        guestDetail: state.store.home.guestDetails,
        cardChecksData: state.store2.cardChecksData,
        guestIsLoggedIn: state.store2.guestIsLoggedIn,
        installedAppVersion: state.store.installedAppVersion,
        installedAppBuildNo: state.store.installedAppBuildNo,
        currentHomePage: state.store2.currentHomePage,
    }
}

export default connect(mapStateToProps, { sendAnalytics, closeOrderPopUp })(withTranslation('translations')(Disclaimer));